module.exports = __webpack_public_path__ + "static/media/Information.006b5b6f.svg";